import React from 'react';

import {
  FloatingFocusManager,
  FloatingPortal,
  useMergeRefs,
} from '@floating-ui/react';

import * as Styled from './Popover.styled';
import { usePopoverContext } from './Provider';

export interface PopoverContentProps extends React.HTMLProps<HTMLDivElement> {
  closeOnFocusOut?: boolean;
  initialFocus?: number | React.MutableRefObject<HTMLElement | null>;
}

export const PopoverContent = React.forwardRef<
  HTMLDivElement,
  PopoverContentProps
>(function PopoverContent(
  { style, className, closeOnFocusOut = true, initialFocus, ...props },
  propRef,
) {
  const { context: floatingContext, ...context } = usePopoverContext();
  const ref = useMergeRefs([context.refs.setFloating, propRef]);

  if (!floatingContext.open) {
    return null;
  }

  return (
    <FloatingPortal>
      <FloatingFocusManager
        context={floatingContext}
        modal={context.modal}
        closeOnFocusOut={closeOnFocusOut}
        initialFocus={initialFocus}
      >
        <Styled.PopoverContent
          ref={ref}
          aria-describedby={context.descriptionId}
          aria-labelledby={context.labelId}
          className={className}
          style={{ ...context.floatingStyles, ...style }}
          {...context.getFloatingProps(props)}
        >
          {props.children}
        </Styled.PopoverContent>
      </FloatingFocusManager>
    </FloatingPortal>
  );
});
